import { render, staticRenderFns } from "./PortalsOverview.vue?vue&type=template&id=33a09f5a&scoped=true"
import script from "./PortalsOverview.vue?vue&type=script&lang=js"
export * from "./PortalsOverview.vue?vue&type=script&lang=js"
import style0 from "./PortalsOverview.vue?vue&type=style&index=0&id=33a09f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a09f5a",
  null
  
)

export default component.exports